module.exports = __webpack_public_path__ + "5cca04bfd33c5dd0dce5ab44eb19bf08.jpg";